import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./components/shared/Navbar";
import Footer from "./components/shared/Footer";
import ScrollToTop from "./utils/ScrollToTop";
import StructuredData from "./components/shared/StructuredData";

const App = () => {
  return (
    <Router>
      <StructuredData />
      <ScrollToTop />
      <Navbar />
      <ToastContainer />
      <AppRoutes />
      <Footer />
    </Router>
  );
};

export default App;
